'use client';

import { Skeleton } from '@mui/material';
import { FC } from 'react';
import {
  CompanyLogo,
  CompanyNameRow,
  ContactsGrid,
  Container,
  ContentCard,
  HeroBanner,
  PriceCard,
  PriceCardHeader,
  PricesGrid,
  Section,
} from '../../styled';

export const BrokerProfileSkeleton: FC = () => (
  <Container>
    <Skeleton variant="text" width={220} height={44} animation="wave" sx={{ mb: '22px' }} />
    <ContentCard>
      <HeroBanner>
        <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
      </HeroBanner>

      <Section>
        <CompanyNameRow>
          <CompanyLogo>
            <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
          </CompanyLogo>
          <Skeleton variant="text" width="40%" height={32} animation="wave" />
          <Skeleton variant="rectangular" width={120} height={38} animation="wave" sx={{ borderRadius: '6px', flexShrink: 0 }} />
        </CompanyNameRow>
      </Section>

      <Section>
        <Skeleton variant="text" width={140} height={28} animation="wave" />
        <Skeleton variant="text" width="90%" height={16} animation="wave" />
        <Skeleton variant="text" width="75%" height={16} animation="wave" />
        <Skeleton variant="text" width="60%" height={16} animation="wave" />
      </Section>

      <Section>
        <Skeleton variant="text" width={160} height={28} animation="wave" />
        <ContactsGrid>
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} variant="rectangular" height={60} animation="wave" sx={{ borderRadius: '6px' }} />
          ))}
        </ContactsGrid>
      </Section>

      <Section>
        <Skeleton variant="text" width={120} height={28} animation="wave" />
        <PricesGrid>
          <PriceCard>
            <PriceCardHeader>
              <Skeleton variant="rectangular" width={40} height={40} animation="wave" sx={{ borderRadius: '6px' }} />
              <Skeleton variant="text" width={100} height={20} animation="wave" />
            </PriceCardHeader>
            <Skeleton variant="text" width={180} height={28} animation="wave" />
          </PriceCard>
          <PriceCard>
            <PriceCardHeader>
              <Skeleton variant="rectangular" width={40} height={40} animation="wave" sx={{ borderRadius: '6px' }} />
              <Skeleton variant="text" width={100} height={20} animation="wave" />
            </PriceCardHeader>
            <Skeleton variant="text" width={180} height={28} animation="wave" />
          </PriceCard>
        </PricesGrid>
      </Section>
    </ContentCard>
  </Container>
);
